import { JrcPalette } from "@jeekim-company/jeekim-react-core";

export class Palette extends JrcPalette {}
